import { render, staticRenderFns } from "./Vendedores.vue?vue&type=template&id=b7029922&lang=pug"
import script from "./Vendedores.vue?vue&type=script&lang=js"
export * from "./Vendedores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports